export default __webpack_public_path__ + "static/media/etapa1.66cd4933.png";